var _focusVisible;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/skip-link.ts
import { cssVar, defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
var $bg = cssVar("skip-link-bg");
var baseStyle = defineStyle({
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: (_focusVisible = {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6"
  }, _defineProperty(_focusVisible, $bg.variable, "colors.white"), _defineProperty(_focusVisible, "_dark", _defineProperty({}, $bg.variable, "colors.gray.700")), _defineProperty(_focusVisible, "bg", $bg.reference), _focusVisible)
});
var skipLinkTheme = defineStyleConfig({
  baseStyle: baseStyle
});
export { skipLinkTheme };